import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import VotesSidebar from "../VotesSidebar/VotesSidebar";
import "./Votes.css";
import ff from "../../images/pp-logo.gif";
import { END_URL, IMG_URL } from "../../config";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import v2 from "../../images/v1.png"
import v1 from "../../images/v2.png"
import v3 from "../../images/right-y.png"
import v4 from "../../images/left-y.png"
import v5 from "../../images/think.png"
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import DOMPurify from "dompurify";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";


const tabs = ["Latest", "Most Voted"];

const voteOptions = [
    { key: "wiring", label: "Just Your Wiring", tone: "green" },
    { key: "weird", label: "You Made It Weird", tone: "pink" },
    { key: "notYou", label: "Not you This Time", tone: "purple" },
    { key: "mess", label: "Everyone's a Mess", tone: "yellow" },
];

const iconPaths = {
    infinity: "M6 12c0-2 1.5-3.5 3.3-3.5 3 0 3.4 7 6.4 7C17.5 15.5 19 14 19 12s-1.500-3.500-3.300-3.500c-3 0-3.400 7-6.400 7C7.500 15.500 6 14 6 12z",
    heart: "M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.600A4 4 0 0 1 19 10c0 5.600-7 10-7 10z",
    bolt: "M13 3L5 14h6l-1 7 8-11h-6l1-7z",
    shield: "M12 3l7 3v5c0 5-3 8.500-7 10-4-1.500-7-5-7-10V6l7-3z",
};

const staticPosts  = [
    {
        id: 1,
        initials: "TF",
        avatarTone: "peach",
        author: "The Firebrand",
        code: "QYHWZA",
        posted: "Posted 1 day ago",
        title:
            "I left a group holiday three days early because everyone was annoying me. Is it just my personality?",
        description:
            "We went on a week-long trip with friends I genuinely like, but by day 3 I was completely overwhelmed. The constant chatter, the group decisions, the \"let's all do everything together\" energy... I just needed to be away from it. So I booked an early flight home. Now a few people are annoyed and think I overreacted. Was this just my personality showing, or did I actually handle this badly?",
        image: "/images/votes/holiday-hat.jpg",
        groups: [
            { name: "Haven", icon: "infinity", tone: "yellow", result: "74% Not You This Time", percent: 74, bar: "green" },
            { name: "Sanctum", icon: "heart", tone: "pink", result: "81% you Made it Wierd", percent: 81, bar: "pink" },
            { name: "Cadence", icon: "bolt", tone: "purple", result: "Split almost evenly", percent: 50, bar: "purple" },
            { name: "Maverick", icon: "shield", tone: "green", result: "62% Just Your wiring", percent: 62, bar: "yellow" },
        ],
        // 7.4K total votes: 28% / 34% / 26% / 12%
        initialVotes: { wiring: 2072, weird: 2516, notYou: 1924, mess: 888 },
    },
    {
        id: 2,
        initials: "TF",
        avatarTone: "blue",
        author: "The Firebrand",
        code: "QYHWZA",
        posted: "Posted 1 day ago",
        title:
            "I left a group holiday three days early because everyone was annoying me. Is it just my personality?",
        description:
            "We went on a week-long trip with friends I genuinely like, but by day 3 I was completely overwhelmed. The constant chatter, the group decisions, the \"let's all do everything together\" energy... I just needed to be away from it. So I booked an early flight home. Now a few people are annoyed and think I overreacted. Was this just my personality showing, or did I actually handle this badly?",
        image: "/images/votes/cozy-bed.jpg",
        groups: [
            { name: "Harmony", icon: "infinity", tone: "yellow", result: "74% Not You This Time", percent: 74, bar: "green" },
            { name: "Nomad", icon: "heart", tone: "pink", result: "81% you Made it Wierd", percent: 81, bar: "pink" },
            { name: "Rally", icon: "bolt", tone: "purple", result: "Split almost evenly", percent: 50, bar: "purple" },
            { name: "Rogue", icon: "shield", tone: "green", result: "62% Just Your wiring", percent: 62, bar: "yellow" },
        ],
        initialVotes: { wiring: 2072, weird: 2516, notYou: 1924, mess: 888 },
    },
];

const Icon = ({ name }) => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d={iconPaths[name]} />
    </svg>
);

const formatTotal = (total) => total >= 1000 ? `${(total / 1000).toFixed(1)}K` : `${total}`;

const timeAgo = (dateString) => {
    if (!dateString) return "";
    const seconds = Math.floor((Date.now() - new Date(dateString).getTime()) / 1000);
    if (seconds < 0) return "Just now";
    if (seconds < 60) return "Just now";
    const intervals = [
        { label: "year", seconds: 31536000 },
        { label: "month", seconds: 2592000 },
        { label: "week", seconds: 604800 },
        { label: "day", seconds: 86400 },
        { label: "hour", seconds: 3600 },
        { label: "minute", seconds: 60 },
    ];
    for (const interval of intervals) {
        const value = Math.floor(seconds / interval.seconds);

        if (value >= 1) {
            return `${value} ${interval.label}${value > 1 ? "s" : ""} ago`;
        }
    }
    return "Just now";
};

const Votes = ({token, onsignup}) => {
    // { [postId]: { counts: {...}, selected: key | null } }

    const [posts, setPosts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("Latest");
    const [pagination, setPagination] = useState(null);
    const [pageLoading, setPageLoading] = useState(false);
    const [loadingPageNumber, setLoadingPageNumber] = useState(null);
    const [voteState, setVoteState] = useState({});
    const [postsLoading, setPostsLoading] = useState(true);
    const [showFreeSub, setshowFreeSub] = useState(false);
    const [userAttentFreeTest, setUserAttentFreeTest] = useState(false);
    const [showShareModal, setShowShareModal] = useState(false);
    const [shareTitle, setShareTitle] = useState("");
    const [shareDescription, setShareDescription] = useState("");
    const [shareImage, setShareImage] = useState(null);
    const [shareImagePreview, setShareImagePreview] = useState("");
    const [shareError, setShareError] = useState("");
    const [shareSubmitting, setShareSubmitting] = useState(false);
    const quillModules = {
        toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"],
            ["clean"],
        ],
    };
    const quillFormats = ["bold", "italic", "underline", "list", "bullet", "link", ];
    const [optionLabels, setOptionLabels] = useState({post_option_1: "Just Your Wiring", post_option_2: "You Made It Weird", post_option_3: "Not You This Time", post_option_4: "Everyone's A Mess"});
    const voteKeyMap = {wiring: "post_option_1", weird: "post_option_2", notYou: "post_option_3", mess: "post_option_4"};
    const optionToneMap = {post_option_1: "green", post_option_2: "pink", post_option_3: "purple", post_option_4: "yellow"};
    const [freeQuizMessage, setFreeQuizMessage] = useState({free_quiz_message: "", free_quiz_button_text: "Take the Quiz", free_quiz_button_link: "https://personalitypeek.com/result/free-personality-quiz/start"});

    const LoginShow = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        onsignup(true);
    };

    const mapResultDimensionsToGroups = (resultDimensions = [], post) => {
        const template = staticPosts.find((item) => item.id === post.id) || staticPosts[0];
        return resultDimensions.map((dimension, index) => {
            const groupTemplate = template.groups[index % template.groups.length];
            const percentage = Number(dimension.most_vote_percentage) || 0;
            const winningOption = dimension.most_vote_option;
            return {
                name: dimension.item?.name || "Unknown",
                image: dimension.item?.image
                    ? `${IMG_URL}/d0/${dimension.item.image.replace(/^\/+/, "")}`
                    : null,
                result: `${percentage}% ${
                    optionLabels[winningOption] ||
                    winningOption ||
                    ""
                }`,
                percent: percentage,
                tone: groupTemplate?.tone || "green",
                icon: groupTemplate?.icon || "infinity",
                bar: optionToneMap[winningOption] || "green",
            };
        });
    };

    const fetchCommunityPosts = async (page = 1, initial = false) => {
        try {
            if (!initial) {
                setPageLoading(true);
            }
            const token = localStorage.getItem("token");
            const sortBy = activeTab === "Most Voted" ? "most_voted" : "latest";
            const postsResponse = await axios.get(`${END_URL}/community-posts/all`, {
                params: {
                    sort_by: sortBy,
                    page: page,
                },
                headers: {
                    ...(token && {
                        Authorization: `Bearer ${token}`,
                    }),
                    Accept: "application/json",
                },
            });
            const apiPosts = postsResponse.data.posts || [];
            setUserAttentFreeTest(postsResponse.data.user_attent_free_test === true);
            const selectedVoteMap = {
                post_option_1: "wiring",
                post_option_2: "weird",
                post_option_3: "notYou",
                post_option_4: "mess",
            };
            const dynamicPosts = apiPosts.filter((post) => post.approve === true).map((post, index) => {
                const template = staticPosts[index % staticPosts.length];
                return {
                    ...template,
                    id: post.id,
                    profilepic: post.profilepic || null,
                    initials: (post.user_name || "Anonymous").trim().split(/\s+/).filter(Boolean).slice(0, 2).map((word) => word[0].toUpperCase()).join(""),
                    author: post.user_name || "Anonymous",
                    posted: timeAgo(post.created_at),
                    title: post.community_title,
                    description: post.community_text,
                    image: post.community_image_url,
                    logged_in_userid: post.logged_in_userid ?? null,
                    user_vote: post.user_vote ?? null,
                    percentages: {
                        wiring: Number(post.post_option_1) || 0,
                        weird: Number(post.post_option_2) || 0,
                        notYou: Number(post.post_option_3) || 0,
                        mess: Number(post.post_option_4) || 0,
                    },
                    total_vote: Number(post.total_vote) || 0,
                    groups: (post.result_dimensions || []).map((dimension, index) => {
                        const groupTemplate = template.groups[index % template.groups.length];
                        const percentage = Number(dimension.most_vote_percentage) || 0;
                        const winningOption = dimension.most_vote_option;
                        const imagePath = dimension.item?.image;
                        return {
                            name: dimension.item?.name || "Unknown",
                            image: imagePath ? `${IMG_URL}/d0/${imagePath.replace(/^\/+/, "")}` : null,
                            result: `${percentage}% ${
                                optionLabels[winningOption] ||
                                winningOption ||
                                ""
                            }`,
                            percent: percentage,
                            tone: groupTemplate?.tone || "green",
                            icon: groupTemplate?.icon || "infinity",
                            bar: optionToneMap[winningOption] || "green",
                        };
                    }),
                };
            });
            setPosts(dynamicPosts);
            setPagination(postsResponse.data.pagination);
            setVoteState(dynamicPosts.reduce((acc, post) => {
                acc[post.id] = {
                    counts: post.percentages,
                    total: post.total_vote,
                    selected: selectedVoteMap[post.user_vote] || null,
                };
                return acc;
            }, {}));
        }
        catch (error) {
            console.error("Error fetching community posts:", error.response?.data || error);
        }
        finally {
            setPostsLoading(false);
            setPageLoading(false);
            setLoadingPageNumber(null);
        }
    };

    const fetchCommunityOptions = async () => {
        try {
            const response = await axios.get(
                `${END_URL}/community-options`
            );

            if (response.data?.success && response.data?.data) {
                const data = response.data.data;
                setFreeQuizMessage({
                    free_quiz_message: data.free_quiz_message || "",
                    free_quiz_button_text: data.free_quiz_button_text || "Take the Quiz",
                    free_quiz_button_link: data.free_quiz_button_link || "https://personalitypeek.com/result/free-personality-quiz/start",
                });
            }
        } catch (error) {
            console.error("Error fetching community options:", error);
        }
    };

    const handleVote = async (postId, optionKey) => {
        const token = localStorage.getItem("token");
        if (!token) {
            LoginShow();
            return;
        }
        if (!userAttentFreeTest) {
            setshowFreeSub(true);
            return;
        }
        try {
            const response = await axios.post(`${END_URL}/community-votes`, {
                community_post_id: postId,
                vote: voteKeyMap[optionKey],
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });
            if (response.data?.success) {
                const data = response.data.data;
                const resultDimensions = response.data.result_dimensions || [];

                setVoteState((prev) => {
                    const current = prev[postId];

                    if (!current) return prev;

                    return {
                        ...prev,
                        [postId]: {
                            ...current,
                            selected: optionKey,
                            total: Number(data.total_vote) || 0,
                            counts: {
                                wiring: Number(data.post_option_1) || 0,
                                weird: Number(data.post_option_2) || 0,
                                notYou: Number(data.post_option_3) || 0,
                                mess: Number(data.post_option_4) || 0,
                            },
                        },
                    };
                });

                setPosts((prevPosts) =>
                    prevPosts.map((post) =>
                        post.id === postId
                            ? {
                                ...post,
                                total_vote: Number(data.total_vote) || 0,
                                groups: mapResultDimensionsToGroups(
                                    resultDimensions,
                                    post
                                ),
                            }
                            : post
                    )
                );
            }
        }
        catch (error) {
            console.error("Error saving vote:", error.response?.data || error);
            if (error.response?.status === 401) {
                LoginShow();
            }
            else {
                alert(error.response?.data?.message || "Unable to save your vote.");
            }
        }
    };

    const totalPages = pagination?.last_page || 1;
    const currentPosts = posts;

    const { slug } = "free-personality-quiz";

    const [hub, setHub] = useState(null);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchHub();
        fetchCommunityOptions();
    }, [slug]);

    useEffect(() => {
        setCurrentPage(1);
    }, [activeTab]);

    useEffect(() => {
        fetchCommunityPosts(currentPage, posts.length === 0);
    }, [activeTab, currentPage]);

    const handlePageChange = (page) => {
        if (page === currentPage || page < 1 || page > (pagination?.last_page || 1) || pageLoading) {
            return;
        }
        setLoadingPageNumber(page);
        setCurrentPage(page);
    };

    const getPaginationPages = () => {
        if (!pagination?.last_page) return [];
        const total = pagination.last_page;
        const current = currentPage;
        if (total <= 7) {
            return Array.from({
                length: total
            }, (_, i) => i + 1);
        }
        if (current <= 4) {
            return [1, 2, 3, 4, 5, "...", total];
        }
        if (current >= total - 3) {
            return [
                1, "...",
                total - 4,
                total - 3,
                total - 2,
                total - 1,
                total,
            ];
        }
        return [
            1, "...",
            current - 2,
            current - 1,
            current,
            current + 1,
            current + 2, "...",
            total,
        ];
    };

    const handleShareSituation = () => {
        const token = localStorage.getItem("token");
        if (!token) {
            LoginShow();
            return;
        }
        if (!userAttentFreeTest) {
            setshowFreeSub(true);
            return;
        }
        setShareError("");
        setShareTitle("");
        setShareDescription("");
        setShareImage(null);
        setShareImagePreview("");
        setShowShareModal(true);
    };

    const handleShareImageChange = (e) => {
	    const file = e.target.files?.[0];
        if (!file) return;
        const allowedTypes = ["image/jpeg", "image/png", "image/webp", ];
        const maxSize = 5 * 1024 * 1024; // 5 MB
        if (!allowedTypes.includes(file.type)) {
            setShareError("Only JPEG, PNG, and WEBP images are allowed.");
            e.target.value = "";
            return;
        }
        if (file.size > maxSize) {
            setShareError("Image size must not exceed 5 MB.");
            e.target.value = "";
            return;
        }
        setShareError("");
        setShareImage(file);
        setShareImagePreview(URL.createObjectURL(file));
    };

    const handleShareSubmit = async (e) => {
        e.preventDefault();
        const plainDescription = shareDescription.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
        if (!shareTitle.trim() || !plainDescription) {
            setShareError("Please enter both title and description.");
            return;
        }
        if (shareImage) {
            const allowedTypes = ["image/jpeg", "image/png", "image/webp", ];
            if (!allowedTypes.includes(shareImage.type)) {
                setShareError("Only JPEG, PNG, and WEBP images are allowed.");
                return;
            }
            if (shareImage.size > 5 * 1024 * 1024) {
                setShareError("Image size must not exceed 5 MB.");
                return;
            }
        }
        const token = localStorage.getItem("token");
        if (!token) {
            setShowShareModal(false);
            LoginShow();
            return;
        }
        if (!userAttentFreeTest) {
            setShowShareModal(false);
            setshowFreeSub(true);
            return;
        }
        try {
            setShareSubmitting(true);
            setShareError("");
            const formData = new FormData();
            formData.append("community_title", shareTitle.trim());
            formData.append("community_text", shareDescription);
            if (shareImage) {
                formData.append("community_image", shareImage);
            }
            const response = await axios.post(`${END_URL}/community-posts`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            setShowShareModal(false);
            setShareTitle("");
            setShareDescription("");
            setShareImage(null);
            setShareImagePreview("");
            await fetchCommunityPosts(currentPage);
        }
        catch (error) {
            if (error.response?.status === 422) {
                const validationErrors = Object.values(error.response.data.errors || {}).flat();
                setShareError(validationErrors.join(" ") || "Please check the submitted fields.");
            }
            else if (error.response?.status === 401) {
                setShowShareModal(false);
                LoginShow();
            }
            else {
                setShareError(error.response?.data?.message || "Unable to submit your situation. Please try again.");
            }
        }
        finally {
            setShareSubmitting(false);
        }
    };

    const fetchHub = async () => {
        try {
            setLoading(true);

            const response = await axios.get(
                `${END_URL}/hub/${slug}`
            );

            setHub(response.data.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {

        return (

            <div className="loadingDiv" >

                <img src={ff} alt="Loading..." />

            </div>
        );
    }

    return (
        <div className="votes-common">

            <div className="ques-main hub-cont-banner votes-main">

                <div className="container-fluid">

                    <div className="row ques-row">

                        <div className="col-12">

                            <div className="ques-top" style={{ '--banner_image': `url(${IMG_URL}/d0/${hub?.quiz_banner})` }}>

                                <div className="ques-top-title">
                                    {/* <div className="quiz-banner-content" dangerouslySetInnerHTML={{ __html: hub?.quiz_content }} /> */}

                                    {/* <div dangerouslySetInnerHTML={{ __html: hub?.quiz_reveal_content }} /> */}
                                    <div className="ques-top-title-div1">
                                        <div className="banner-text">
                                            <div className="quiz-banner-content">
                                            <h3>Is It Just My <span>Personality?</span></h3>
                                            <h1>Real situations. 64 personalities. Questionable decisions.</h1>
                                            </div>

                                            <div className="hub-banner-bnts">
                                            <button
                                                type="button"
                                                className="new-commom-btn adapter-btn"
                                                onClick={handleShareSituation}
                                            >
                                                <span>Share Your Situation</span>
                                                <span className="righ-arr">
                                                    <FontAwesomeIcon icon={faArrowRight} />
                                                </span>
                                            </button>
                                            </div>
                                        </div>

                                        <img className="quiz-banner-art" src={v5} alt="" />
                                    </div>

                                    {!userAttentFreeTest && (
                                        <div className="ques-top-title-div2">
                                            <div className="lock-card">
                                                <div className="icon">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 64 64"
                                                        className="lock-icon"
                                                        aria-hidden="true"
                                                    >
                                                        <path
                                                            d="M20 32V20a12 12 0 0 1 24 0v12"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="6"
                                                            strokeLinecap="butt"
                                                        />
                                                        <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M16 28H48A6 6 0 0 1 54 34V54A6 6 0 0 1 48 60H16A6 6 0 0 1 10 54V34A6 6 0 0 1 16 28Z
                                                            M32 37a4 4 0 0 1 2.5 7.1L36 52H28L29.5 44.1A4 4 0 0 1 32 37Z"
                                                        />
                                                    </svg>
                                                </div>

                                                <p className="lock-text">
                                                    To post, comment, or vote, you must be logged in and have
                                                    completed the Personality Peek quiz.
                                                </p>

                                                <div className="lock-actions">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={() =>
                                                            window.location.href =
                                                                "https://personalitypeek.com/result/free-personality-quiz/start"
                                                        }
                                                    >
                                                        Take the Quiz
                                                    </button>

                                                    {!token && (
                                                        <button
                                                            onClick={LoginShow}
                                                            type="button"
                                                            className="btn btn-outline"
                                                        >
                                                            Login
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <section className="votes">
                <div className="container">
                    <div className="votes-tabs col-lg-8 col-xl-9">
                        {tabs.map((tab) => (
                            <button
                                key={tab}
                                type="button"
                                className={activeTab === tab ? "active" : ""}
                                onClick={() => {
                                    if (activeTab !== tab) {
                                        setActiveTab(tab);
                                        setCurrentPage(1);
                                    }
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>

                    <div className="row">
                        <div className="col-md-8 col-lg-8 col-xl-9">
                            {postsLoading ? (
                                <div className="loadingDiv">
                                    <img src={ff} alt="Loading..." />
                                </div>
                            ) : posts.length === 0 ? (
                                <p>No approved community posts found.</p>
                            ) : (
                                <>
                                <div className="votes-list">
                                    {currentPosts.map((post) => {
                                    const currentVote = voteState[post.id];
                                    if (!currentVote) return null;
                                    const { counts, selected, total } = currentVote;

                                    return (
                                        <article key={post.id} className="votes-card">
                                            <div className="votes-card-user">
                                                <div className={`votes-card-avatar ${post.avatarTone}`}>
                                                    {post.profilepic ? (
                                                        <img
                                                            src={
                                                                post.profilepic.startsWith("http")
                                                                    ? post.profilepic
                                                                    : `${IMG_URL}/d0/${post.profilepic.replace(/^\/+/, "")}`
                                                            }
                                                            alt={post.author}
                                                            className="votes-card-avatar-img"
                                                            onError={(e) => {
                                                                e.currentTarget.style.display = "none";
                                                                e.currentTarget.nextElementSibling.style.display = "flex";
                                                            }}
                                                        />
                                                    ) : null}
                                                    <span style={{ display: post.profilepic ? "none" : "flex" }}>
                                                        {post.initials}
                                                    </span>
                                                </div>
                                                <div className="votes-card-meta">
                                                    {/* <h3>
                                                        {post.author} <span>• {post.code}</span>
                                                    </h3> */}
                                                    <h3>{post.author}</h3>
                                                    <p>{post.posted}</p>
                                                </div>
                                                <button type="button" className="votes-card-more" aria-label="More options">
                                                    <i></i>
                                                    <i></i>
                                                    <i></i>
                                                </button>
                                            </div>

                                            <div className="votes-card-row">
                                                <div className="votes-card-left">
                                                    <div className="votes-card-top">
                                                        <div className="votes-card-content">
                                                            <h2>{post.title}</h2>
                                                            <div
                                                                className="votes-card-description"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: DOMPurify.sanitize(
                                                                        (post.description || "")
                                                                            .replace(/&nbsp;|&#160;|&#xA0;/gi, " ")
                                                                            .replace(/\u00A0/g, " ")
                                                                    ),
                                                                }}
                                                            />
                                                        </div>
                                                        {post.image && (
                                                            <div className="votes-card-media">
                                                                <img src={post.image} alt={post.title} />
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* <div className="votes-card-actions">
                                                        <div className="votes-options">
                                                            {voteOptions.map((option) => (
                                                                <button
                                                                    key={option.key}
                                                                    type="button"
                                                                    className={`${option.tone}${selected === option.key ? " active" : ""}`}
                                                                    onClick={() => handleVote(post.id, option.key)}
                                                                    aria-pressed={selected === option.key}
                                                                >
                                                                    <svg viewBox="0 0 24 24" aria-hidden="true">
                                                                        <circle cx="12" cy="12" r="9" />
                                                                        <path d="M8 12h8" />
                                                                    </svg>
                                                                    <span>{option.label}</span>
                                                                </button>
                                                            ))}
                                                        </div>

                                                        <div className="votes-verdict">
                                                            <div className="votes-verdict-head">
                                                                <h6>Community Verdict</h6>
                                                                <p>{formatTotal(total)} votes</p>
                                                            </div>
                                                            <div className="votes-verdict-bar">
                                                                {voteOptions.map((option) => {
                                                                    const percent = Math.round((counts[option.key] / total) * 100);
                                                                    return (
                                                                        <div
                                                                            key={option.key}
                                                                            className={`votes-verdict-segment ${option.tone}`}
                                                                            style={{ flexGrow: counts[option.key] }}
                                                                            title={`${option.label}: ${percent}%`}
                                                                        >
                                                                            {percent}%
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                </div>

                                                {Number(post.total_vote) > 0 && (
                                                    <div className="votes-card-groups">
                                                        <h4>How different personality Groups voted</h4>

                                                        <ul>
                                                            {post.groups.map((group, index) => (
                                                                <li key={`${group.name}-${index}`}>
                                                                    <div className={`votes-group-icon ${group.bar}`}>
                                                                        {group.image ? (
                                                                            <img
                                                                                src={group.image}
                                                                                alt={group.name}
                                                                                className="votes-group-image"
                                                                                onError={(e) => {
                                                                                    e.currentTarget.style.display = "none";
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <Icon name={group.icon} />
                                                                        )}
                                                                    </div>

                                                                    <div className="votes-group-info">
                                                                        <h5>{group.name}</h5>

                                                                        <p>{group.result}</p>

                                                                        <div className="votes-group-bar">
                                                                            <div
                                                                                className={`votes-group-fill ${group.bar}`}
                                                                                style={{ width: `${group.percent}%` }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>


                                            <div className="votes-card-actions">
                                                <div className="votes-options">
                                                    {voteOptions.map((option) => (
                                                        <button
                                                            key={option.key}
                                                            type="button"
                                                            className={`${option.tone}${selected === option.key ? " active" : ""}`}
                                                            onClick={() => handleVote(post.id, option.key)}
                                                            aria-pressed={selected === option.key}
                                                        >
                                                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                                                <circle cx="12" cy="12" r="9" />
                                                                <path d="M8 12h8" />
                                                            </svg>
                                                            <span>
                                                                {optionLabels[
                                                                    `post_option_${voteOptions.findIndex(
                                                                        (item) => item.key === option.key
                                                                    ) + 1}`
                                                                ] || option.label}
                                                            </span>
                                                        </button>
                                                    ))}
                                                </div>

                                                <div className="votes-verdict">
                                                    {Number(total) > 0 && (
                                                        <div className="votes-verdict-head">
                                                            <h6>Community Verdict</h6>
                                                            <p>{formatTotal(total)} votes</p>
                                                        </div>
                                                    )}

                                                    <div className="votes-verdict-bar">
                                                        {voteOptions.map((option) => {
                                                            const percent = counts[option.key] || 0;

                                                            return (
                                                                <div
                                                                    key={option.key}
                                                                    className={`votes-verdict-segment ${option.tone}`}
                                                                    style={{
                                                                        flexGrow: percent,
                                                                        flexBasis: 0,
                                                                    }}
                                                                    title={`${option.label}: ${percent}%`}
                                                                >
                                                                    {percent}%
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>

                                        </article>
                                    );
                                })}
                            </div>
                            {pagination?.last_page > 1 && (
                                <div className="pagination">
                                    <button
                                        type="button"
                                        disabled={currentPage <= 1 || pageLoading}
                                        onClick={() => handlePageChange(currentPage - 1)}
                                    >
                                        {pageLoading && loadingPageNumber === currentPage - 1
                                            ? "Loading..."
                                            : "Previous"}
                                    </button>

                                    {getPaginationPages().map((page, index) => {
                                        if (page === "...") {
                                            return (
                                                <span
                                                    key={`dots-${index}`}
                                                    className="pagination-dots"
                                                >
                                                    ...
                                                </span>
                                            );
                                        }

                                        return (
                                            <button
                                                key={page}
                                                type="button"
                                                disabled={pageLoading}
                                                className={page === currentPage ? "active" : ""}
                                                onClick={() => handlePageChange(page)}
                                            >
                                                {pageLoading && loadingPageNumber === page ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-1" />
                                                        {page}
                                                    </>
                                                ) : (
                                                    page
                                                )}
                                            </button>
                                        );
                                    })}

                                    <button
                                        type="button"
                                        disabled={
                                            currentPage >= pagination.last_page || pageLoading
                                        }
                                        onClick={() => handlePageChange(currentPage + 1)}
                                    >
                                        {pageLoading && loadingPageNumber === currentPage + 1
                                            ? "Loading..."
                                            : "Next"}
                                    </button>
                                </div>
                            )}
                        </>
                            )}
                        </div>

                        <div className="col-md-4 col-lg-4 col-xl-3">
                            <VotesSidebar />
                        </div>
                    </div>
                </div>
            </section>

            {showShareModal && (
                <div
                    className="community-posts-modal-overlay"
                    onClick={() => {
                        if (!shareSubmitting) {
                            setShowShareModal(false);
                            setShareError("");
                        }
                    }}
                >
                    <div
                        className="community-posts-modal"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="share-situation-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="community-posts-modal-header">
                            <h4 id="share-situation-title">
                                Share Your Situation
                            </h4>

                            <button
                                type="button"
                                className="community-posts-close"
                                onClick={() => {
                                    setShowShareModal(false);
                                    setShareError("");
                                }}
                                disabled={shareSubmitting}
                                aria-label="Close modal"
                            >
                                &times;
                            </button>
                        </div>

                        <form onSubmit={handleShareSubmit}>
                            <div className="community-posts-modal-body">
                                {shareError && (
                                    <div className="alert alert-danger" role="alert">
                                        {shareError}
                                    </div>
                                )}

                                <div className="form-group mb-3">
                                    <label
                                        htmlFor="share-post-title"
                                        className="form-label"
                                    >
                                        Title
                                    </label>

                                    <input
                                        id="share-post-title"
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter post title"
                                        value={shareTitle}
                                        onChange={(e) => setShareTitle(e.target.value)}
                                        maxLength={255}
                                        required
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <label
                                        htmlFor="share-post-description"
                                        className="form-label"
                                    >
                                        Description
                                    </label>

                                    <div id="share-post-description">
                                        <ReactQuill
                                            theme="snow"
                                            value={shareDescription}
                                            onChange={setShareDescription}
                                            modules={quillModules}
                                            formats={quillFormats}
                                            placeholder="Enter post description"
                                        />
                                    </div>
                                </div>

                                <div className="form-group mb-3">
                                    <label
                                        htmlFor="share-post-image"
                                        className="form-label"
                                    >
                                        Community Image (optional)
                                        <small className="text-muted d-block">
                                            Accepted formats: JPEG, PNG, WEBP.
                                            Maximum size: 5 MB.
                                        </small>
                                    </label>

                                    <input
                                        id="share-post-image"
                                        type="file"
                                        className="form-control"
                                        accept="image/jpeg,image/png,image/webp"
                                        onChange={handleShareImageChange}
                                    />

                                    {shareImagePreview && (
                                        <img
                                            src={shareImagePreview}
                                            alt="Situation preview"
                                            style={{
                                                width: "100%",
                                                maxWidth: "300px",
                                                marginTop: "12px",
                                                borderRadius: "8px",
                                            }}
                                        />
                                    )}
                                </div>
                            </div>

                            <div className="community-posts-modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowShareModal(false);
                                        setShareError("");
                                    }}
                                    disabled={shareSubmitting}
                                >
                                    Cancel   
                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={shareSubmitting}
                                >
                                    {shareSubmitting
                                        ? "Submitting..."
                                        : "Share Situation"}  
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {showFreeSub && (
                <div className="newdashpop-overlay subs-cognit-modal1 dash-dil-12-pop votes-pop">
                    <div className="newdashpop-inner">
                        <div className="newdashpop-container sub-no">
                            <button type="button" className="newdashpop-close" onClick={()=> setshowFreeSub(false)} aria-label="Close popup" > &times;
                            </button>

                            <div className="conent-pop subs-left">
                                <div className="conent-pop-text" dangerouslySetInnerHTML={{ __html: freeQuizMessage.free_quiz_message }} />
                                <button type="button" onClick={()=> { window.location.href = freeQuizMessage.free_quiz_button_link || "https://personalitypeek.com/result/free-personality-quiz/start"; }} > {freeQuizMessage.free_quiz_button_text || "Take the Free Quiz"}
                                <span> <FontAwesomeIcon className="icc" icon={faArrowRight} /></span> 
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                )}

        </div>
    );
};

export default Votes;